var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"theme2-wrapper"},[_c('theme2-the-header'),_c('router-view'),_c('theme2-the-footer'),_c('theme-changer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }